export enum ModelHoldingPosition {
    Buy = 'B',
    Hold = 'H',
}
